export const siteLanguagesEng = 'en';
export const siteLanguagesFr = 'fr';
export const globalErrorMsgEng = 'Please correct the errors below.';
export const globalErrorMsgFr = 'Merci de corriger les erreurs ci-dessous';
